import Vue from 'vue'
import Router from 'vue-router'
//Main
import SearchCatering from '@/components/SearchCatering'
//Main Users
import RegisterUser from '@/components/users/RegisterUser'
//Main Catering
import InfoCatering from '@/components/catering/InfoCatering'
import SupervisorCatering from '@/components/catering/SupervisorCatering'
//import VotesCatering from '@/components/catering/VotesCatering'
//import CommentsCatering from '@/components/catering/CommentsCatering'
//Main Menu
import ListMenuToday from '@/components/menu/ListMenuToday'
import ListMenuWeek from '@/components/menu/ListMenuWeek'
//Main Dish
import InfoDish from '@/components/dish/InfoDish'
import CommentsDish from '@/components/dish/CommentsDish'
import IngredientsDish from '@/components/dish/IngredientsDish'
//import VotesDish from '@/components/dish/VotesDish'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'SearchCatering',
      component: SearchCatering
    },
    {
      path: '/registrar/',
      name: 'RegisterUser',
      component: RegisterUser
    },
    {
      path: '/catering/:cateringId',
      name: 'InfoCatering',
      component: InfoCatering
    },/*
    {
      path: '/catering/:cateringId/super/:id',
      name: 'SupervisorCatering',
      component: SupervisorCatering
    },
    {
      path: '/catering/:cateringId/menu/today/:id',
      name: 'ListMenuToday',
      component: ListMenuToday
    },
    {
      path: '/catering/:cateringId/menu/week/:id',
      name: 'ListMenuWeek',
      component: ListMenuWeek
    },*/
    {
      path: '/plato/:dishId',
      name: 'InfoDish',
      component: InfoDish
    },/*
    {
      path: '/plato/:cateringId/plato/:dishId/ingre/',
      name: 'IngredientsDish',
      component: IngredientsDish
    },
    {
      path: '/plato/:cateringId/plato/:dishId/comments/',
      name: 'CommentsDish',
      component: CommentsDish
    },*/
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js